/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-checkbox-container[_ngcontent-%COMP%]{margin-bottom:15px}form[_ngcontent-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;margin-bottom:0}.create-another[_ngcontent-%COMP%]{margin-right:auto;margin-left:5px}.robot-create-cancel[_ngcontent-%COMP%]{margin-left:auto}.robot-type-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:18px;font-weight:500;margin:0}.robot-type-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:14px;margin:0 0 25px}"];
export { styles as styles };
